import ProfitLossHTMLPreviewShowRatesStrategy from './ProfitLossHTMLPreviewShowRatesStrategy'
import ProfitLossHTMLPreviewHideRatesStrategy from './ProfitLossHTMLPreviewHideRatesStrategy'
import ProfitLossHTMLPreviewHeaderSection from './ProfitLossHTMLPreviewHeaderSection'
import ProfitLossHTMLPreviewGeneralCostsSection from './ProfitLossHTMLPreviewGeneralCostsSection'
import ProfitLossHTMLPreviewGroupingSection from './ProfitLossHTMLPreviewGroupingSection'
import ProfitLossHTMLPreviewGrandTotalSection from './ProfitLossHTMLPreviewGrandTotalSection'

export default function ProfitLossHTMLPreviewGenerator() {}

ProfitLossHTMLPreviewGenerator.prototype.init = function()
{
    return this;
};

ProfitLossHTMLPreviewGenerator.prototype.generatePreviewTable = function( reportParameters )
{
    var table = document.createElement( "table" );
    table.className = "reportHtmlPreviewTable profitLoss " + (reportParameters.showSpentTime ? "showSpentTime" : "");
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    var columnsStrategy = reportParameters.showAverageRates ?
                          new ProfitLossHTMLPreviewShowRatesStrategy().init( reportParameters.timeFormat,
                                                                             reportParameters.showSpentTime ) :
                          new ProfitLossHTMLPreviewHideRatesStrategy().init( reportParameters.timeFormat,
                                                                             reportParameters.showSpentTime );

    var header = new ProfitLossHTMLPreviewHeaderSection().init(columnsStrategy);

    var groupingRowsCount = 3;
    var generalCostsSection = null;
    if( reportParameters.showLeaveTimeCosts || reportParameters.showOvertimeAddition )
    {
        generalCostsSection = new ProfitLossHTMLPreviewGeneralCostsSection().init( reportParameters.showLeaveTimeCosts, reportParameters.showOvertimeAddition, columnsStrategy );
        if( !reportParameters.showLeaveTimeCosts )
            groupingRowsCount += 2;
        if( !reportParameters.showOvertimeAddition )
            groupingRowsCount ++;
    }
    else
    {
        groupingRowsCount += 4;
    }

    var groupingSection = new ProfitLossHTMLPreviewGroupingSection().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            reportParameters.thirdGroupingLevel,
            columnsStrategy, groupingRowsCount
    );
    var grandTotalSection = new ProfitLossHTMLPreviewGrandTotalSection().init( columnsStrategy );

    header.addRows( tBody );
    groupingSection.addRows( tBody );
    if( generalCostsSection )
        generalCostsSection.addRows( tBody );
    grandTotalSection.addRows( tBody );

    return table;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewGenerator.js